// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__EC3Sb","checkbox":"index_checkbox__5GXSI","text":"index_text__Uy4m1"};